import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Image, Input, Row, message } from "antd";
import { EditFilled } from "@ant-design/icons";
import axios from "axios"; // Ensure axios is imported for API calls
import colors from "./constants/Colors";
import cover from "../../src/assets/images/cover.png";
import profile_img from "../assets/images/profile_img.png";

const Profile = () => {
  // State to store profile data
  const [profile, setProfile] = useState({
    firstName: "",
    lastName: "",
    email: "",
    picNumber: "",
    organisationName: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(
          " https://eutracker.rdiup.com/v1/user/getProfile/",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Assuming you store the token in localStorage
            },
          }
        );
        const responseP = await axios.get(
          " https://eutracker.rdiup.com/v1/partners/",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Assuming you store the token in localStorage
            },
          }
        );
        const part = Number(localStorage.getItem("organisation_name"));
        const partner = responseP.data.find((p) => p.id === part);

        console.log("evkv ", partner.name, part);
        setProfile({
          firstName: response.data.user.firstname,
          lastName: response.data.user.lastname,
          email: response.data.user.email,
          picNumber: response.data.user.pic_number,
          organisationName: partner.name,
        });
        console.log("profile", response.data.user);
        localStorage.setItem("is_admin", response.data.user.is_admin);
      } catch (err) {
        console.log("Failed to fetch profile");
      }
    };

    fetchProfile();
  }, []);

  // Handler to update the profile
  const handleSave = async () => {
    try {
      const response = await axios.put(
        " https://eutracker.rdiup.com/v1/user/getProfile/",
        {
          firstname: profile.firstName,
          lastname: profile.lastName,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Assuming you store the token in localStorage
          },
        }
      );

      if (response.status === 200) {
        message.success("Profile updated successfully");
        window.location.href = "/profile";
      }
    } catch (err) {
      message.error("Failed to update profile");
    }
  };

  const handleCancel = () => {
    console.log("Profile edit canceled");
    // Add logic to handle the cancel action, like resetting the form or redirecting
  };

  return (
    <div style={{ margin: 0, backgroundColor: "white" }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={8}>
          {/* Profile Picture Card */}
          <Card style={{ display: "flex", flexDirection: "column" }}>
            <Form layout="vertical" className="ant-advanced-search-form">
              <Row gutter={24}>
                <Col xs={24}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Image
                      preview={false}
                      width="100%"
                      height={150}
                      style={{ borderRadius: 8 }}
                      src={cover}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: -50,
                      }}
                    >
                      <Image
                        preview={false}
                        width={150}
                        height={150}
                        style={{
                          borderRadius: 80,
                          border: `solid 5px ${colors.primary}`,
                        }}
                        src={profile_img}
                      />
                      {/* <p className="profile-text-bold">
                        Edit photo{" "}
                        <EditFilled style={{ color: colors.primary }} />
                      </p> */}
                      <p style={{ marginTop: 10, fontWeight: "bold" }}>
                        {profile.firstName} {profile.lastName}
                      </p>
                      <p
                        style={{ marginTop: -10 }}
                        className="profile-text-italic"
                      >
                        {profile.email}
                      </p>
                      {profile.is_admin == true ? (
                        <></>
                      ) : (
                        <p
                          style={{ marginTop: -10 }}
                          className="profile-text-italic"
                        >
                          PIC {profile.picNumber} - {profile.organisationName}
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={16}>
          {/* General Information Card */}
          <Card style={{ width: "100%", maxWidth: "800px", margin: "auto" }}>
            <h3>General Information</h3>
            <Form layout="vertical" className="ant-advanced-search-form">
              <Row gutter={16}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item required label="First Name">
                    <Input
                      placeholder="First name"
                      value={profile.firstName}
                      onChange={(e) =>
                        setProfile({ ...profile, firstName: e.target.value })
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item required label="Last Name">
                    <Input
                      placeholder="Last name"
                      value={profile.lastName}
                      onChange={(e) =>
                        setProfile({ ...profile, lastName: e.target.value })
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item required label="Email">
                    <Input
                      placeholder="contact@email.com"
                      value={profile.email}
                      disabled // Email is not editable
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item required label="PIC">
                    <Input
                      placeholder="PIC"
                      value={profile.picNumber}
                      disabled // PIC is not editable
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item required label="Organisation name">
                    <Input
                      placeholder="Organisation name"
                      value={profile.organisationName}
                      disabled // Organisation name is not editable
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} style={{ textAlign: "right" }}>
                  <Button
                    style={{
                      backgroundColor: colors.primary,
                      color: "white",
                      borderColor: colors.primary,
                    }}
                    onClick={handleSave}
                    htmlType="button"
                  >
                    Save
                  </Button>
                  <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Profile;
